module.exports = __webpack_public_path__ + "img/affiliate.1953d663.svg";